import { Navigate } from "react-router-dom";
import { useRole } from "../../RoleContext.js";
import isTokenExpired from "./Auth.js";

const PrivateRoute = ({ children, allowedRoles }) => {
  const { token, role, loading } = useRole(); // ✅ corregido

  if (loading) {
    return <div>Cargando...</div>; // espera a que el token se cargue
  }

  // Si no hay token o está expirado → login
  if (!token || isTokenExpired(token)) {
    console.warn("🔴 Redirigiendo al login (token nulo o expirado)");
    localStorage.removeItem("token");
    return <Navigate to="/login" replace />;
  }

  // Si hay allowedRoles y el role no coincide → unauthorized
  if (allowedRoles && !allowedRoles.includes(role)) {
    console.warn("🟠 Rol no autorizado");
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default PrivateRoute;
